import React from 'react';
import * as R from 'ramda';

import { ReactComponent as AssassinSymbol } from '../assets/assassin.svg';

type Props = {
  value: number[],
};

/**
 * Create a string of a repeated symbol
 * @param num Number of times a symbol should appear
 * @param symbol The symbol in question
 */
const repeatString = (num: number, symbol: string) => (
  R.join('', R.repeat(symbol, Math.abs(num)))
);

/**
 * Display for an individual die result
 * @param props
 */
const DieFaceDisplay: React.FC<Props> = ({ value }) => (
  <span className="dice-display__die-face centre">
    {R.cond([
      [val => val[1] === 1, R.always(<AssassinSymbol className="dice-display__assassin"/>)],
      [val => val[0] > 0, val => repeatString(val[0], '+')],
      [val => val[0] < 0, val => repeatString(val[0], '-')],
      [R.T, R.always('0')],
    ])(value)}
  </span>
);

export default DieFaceDisplay;
